module.exports = __webpack_public_path__ + "static/media/biking.c5ad796d.svg";